module.exports = __webpack_public_path__ + "images/sad-filled29371fce26e93ea3d913633d83ae9ecb.svg";